var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0014 0.19873C6.33474 0.19873 2.83651 2.36747 1.37226 5.7903C0.00954705 8.97572 0.747253 11.6866 2.28322 14.0078C3.54253 15.911 5.37925 17.6095 7.03628 19.1419L7.03706 19.1426C7.35278 19.4346 7.66196 19.7206 7.95938 20.0007L7.96096 20.0022C8.512 20.5181 9.24407 20.8029 10.0014 20.8029C10.7589 20.8029 11.491 20.5181 12.042 20.0021C12.3233 19.7388 12.6149 19.47 12.9124 19.196C14.5874 17.6526 16.45 15.9365 17.7224 14.0092C19.2566 11.6855 19.9917 8.97179 18.6307 5.7903C17.1664 2.36747 13.6682 0.19873 10.0014 0.19873ZM10 5.70915C7.88291 5.70915 6.16667 7.42539 6.16667 9.54248C6.16667 11.6595 7.88291 13.3758 10 13.3758C12.1171 13.3758 13.8333 11.6595 13.8333 9.54248C13.8333 7.42539 12.1171 5.70915 10 5.70915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeLocation);
export default __webpack_public_path__ + "static/media/officeLocation.efdafb191aad2f1bd2aa8cca35f20233.svg";
export { ForwardRef as ReactComponent };